import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, mergeMap } from 'rxjs';
import { Store } from '@ngrx/store';
import { PropertyDetailService } from './property-detail.service';
import { propertyDetailActions } from './property-detail.actions';

@Injectable()
export class PropertyDetailEffects {
  private store = inject(Store);
  private actions$ = inject(Actions);
  private propertyDetailService = inject(PropertyDetailService);

  loadDetails$ = createEffect(() =>
    this.actions$.pipe(
      ofType(propertyDetailActions.detailsLoad),
      mergeMap(action =>
        this.propertyDetailService.getPropertyDetail(action.id).pipe(
          map(res => {
            if (res.success) {
              return propertyDetailActions.detailsLoaded({
                status: 'success',
                message: null,
                property: res.data
              });
            } else {
              return propertyDetailActions.detailsLoaded({
                status: 'error',
                message: res.niceErrorMessage,
                property: null
              });
            }
          })
        )
      )
    )
  );
}
